import React, { useState, useEffect } from 'react';

export const StateContext = React.createContext();


const StateContextProvider = (props) => {

    const [ subtitleQue, setSubtitleQue ] = useState([]);
    const [ letterPositions, setLetterPositions ] = useState([]);
    const [ recPos, setRecPos ] = useState(false);
    const [ shareId, setShareId ] = useState();
    const [ hasChanged, setHasChanged ] = useState(false)
    const [ preComp, setPreComp ] = useState()
    const [ globalZ, setGlobalZ ] = useState(1)


    useEffect(() => {
        console.log("CONTEXT RENDER")
    }, []);
    useEffect(() => {
        if (recPos) {
            setTimeout(() => {
                setRecPos(false)
                saveLetterPositions(letterPositions, shareId)
                setLetterPositions([])
            }, 500)
        }
    }, [ recPos ]);

    useEffect(() => {
        if(shareId) {
            setRecPos(true)
            console.log(shareId);

        }
    }, [ shareId ])

    function removeSubtitle(id) {

        const newQue = subtitleQue.filter(sub => {
            if (sub && sub.id !== id) {
                return sub
            }
        })
        setSubtitleQue(newQue)
    }

    function readLetterPositions(index, pos) {
        letterPositions.push(pos);
        setLetterPositions(letterPositions);
    }

    function saveLetterPositions(arr, id) {
        console.log(id)
        const url = `${process.env.REACT_APP_API_URL}/compositions`
        const data = {
            'id': null,
            'shareId': id,
            'positions': arr
        }
        fetch(
            url,
            {
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data),
                method: "POST"
            }
        )
            .then(data => data.json())
            .then((json) => {
                console.log(JSON.stringify(json))
            })
    }

    function loadSubtitle(sub) {

        setSubtitleQue([ sub, ...subtitleQue ])
    }


    return (
        <StateContext.Provider
            value={
                {
                    subtitleQue: subtitleQue,
                    loadSubtitle: loadSubtitle,
                    removeSubtitle: removeSubtitle,
                    letterPositions: letterPositions,
                    setPositions: readLetterPositions,
                    recPos: recPos,
                    setRec: setRecPos,
                    setShareId: setShareId,
                    hasChanged: hasChanged,
                    setHasChanged: setHasChanged,
                    preComp: preComp,
                    setPreComp: setPreComp,
                    globalZ: globalZ,
                    setGlobalZ: setGlobalZ
                }
            }
        >
            {props.children}
        </StateContext.Provider>

    );
}

export default StateContextProvider